// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'shared/components/Icon';
import classes from './StepProgressBar.module.scss';

/** @type { StatelessComponent<{stepLabels: string[], currentStep: number}> } */
const StepProgressBar = ({ stepLabels, currentStep }) => (
  <div className={classes.container}>
    <ol className={classes.progress_bar}>
      {stepLabels.map((step, idx) => {
        const thisStep = idx + 1; // .map zero indexes, so step 1 == idx 0
        const stepClasses = cx(classes.step, {
          __spec_class__active: currentStep === thisStep,
          [classes.is_current]: currentStep === thisStep,
          [classes.is_complete]: currentStep > thisStep,
        });
        return (
          <li key={step} className={stepClasses}>
            <Icon name="checkmark" />
            <span className={classes.step_label}>
              {thisStep}. {step}
            </span>
          </li>
        );
      })}
    </ol>
  </div>
);

StepProgressBar.displayName = 'StepProgressBar';

StepProgressBar.propTypes = {
  stepLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default StepProgressBar;
